// @flow
import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import { withRouter } from 'react-router';
import typeof History from 'react-router-dom';
import * as sidePanelActionCreators from 'esm-web-pro/redux/side-panel/actions';
import { ApiFormWithModel } from 'esm-web-pro/containers/forms/FormWithModel';
import BaseEditor from 'esm-web-pro/containers/map/editor/BaseEditor';
import typeof Point12 from './Point12';

type Props = {
    id: string,
    point: Point12,
    onClose: Function,
    onSave: Function,
    resource: string,
    // eslint-disable-next-line react/no-unused-prop-types
    history: History,
    match: Object,
    updateObject: Function,
    // eslint-disable-next-line react/no-unused-prop-types
    objectLayer: Object,
    // eslint-disable-next-line react/no-unused-prop-types
    editor: BaseEditor,
    setSensitivity: (key: string, sensitivity: boolean) => void,
};


@withRouter
@connect(null, (dispatch) => (bindActionCreators(sidePanelActionCreators, dispatch)))
class Point12Editor extends React.Component<Props> {
    formRef: { current: null | React.ElementRef<Formik> } = null;

    constructor(props: Props) {
        super(props);
        this.formRef = React.createRef();
    }

    handleUpdate = (response: Object) => {
        const {
            onSave, updateObject, editor,
        } = this.props;
        onSave(response);
        updateObject(response);

        editor._loadFeatures();
    };

    handleClose = () => {
        const {
            onClose,
        } = this.props;
        onClose();
    };

    handleSubmit = (values: Object) => ({ ...values, container: values.container });

    getAdditionalFormProps = (point: Point12) => {
        const formRest = {};
        if (point.container && point.container.type === 'pop') {
            formRest.resourceArguments = [point.container.uuid, point.uuid];
            if (point.type === 'odf') {
                formRest.submitResourceMethod = 'updateODF';
            } else if (point.type === 'switch') {
                formRest.submitResourceMethod = 'updateSwitch';
            }
            formRest.useResourceMethodForSchema = false;
            formRest.useInitial = false;
        }
        if (point.container && point.container.type !== 'pop') {
            if (point.type === 'odf') {
                formRest.resourceName = 'odfNonPop';
            }
        }
        return formRest;
    };

    render() {
        const { point, resource } = this.props;

        const additionalInitial = point.type === 'odf' || point.type === 'switch'
            ? { rack: point.rack?.id ? point.rack.id : point.rack, model: point.model.code } : {};
        const excludedFields = ['infrastructure_provider', 'container', 'map', 'stage', 'ref'];

        if (point.type === 'odf') {
            excludedFields.push('model', 'heightU', 'optical_port_count');
        }

        if (point.type === 'switch') {
            excludedFields.push('model', 'heightU');
        }

        return (
            <>
                <ApiFormWithModel
                    objectType={point.type}
                    forwardRef={this.formRef}
                    resourceName={resource}
                    objectId={point.uuid}
                    excludeFields={excludedFields}
                    initial={{
                        ...point,
                        infrastructure_provider: point.infrastructure_provider.id,
                        container: point.container.id,
                        ...additionalInitial,
                    }}
                    onSave={this.handleUpdate}
                    onClose={this.handleClose}
                    onSubmit={this.handleSubmit}
                    height="100%"
                    // partialUpdate
                    {...this.getAdditionalFormProps(point)}
                />
            </>
        );
    }
}

export default Point12Editor;
